var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5116 90.5529V83.1694C89.5116 79.2529 87.9558 75.4969 85.1864 72.7275C82.4171 69.9582 78.661 68.4023 74.7445 68.4023H45.2104C41.294 68.4023 37.5379 69.9582 34.7685 72.7275C31.9992 75.4969 30.4434 79.2529 30.4434 83.1694V90.5529",
    stroke: "black",
    strokeWidth: 3.85228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.976 53.6357C68.1317 53.6357 74.7431 47.0242 74.7431 38.8686C74.7431 30.713 68.1317 24.1016 59.976 24.1016C51.8204 24.1016 45.209 30.713 45.209 38.8686C45.209 47.0242 51.8204 53.6357 59.976 53.6357Z",
    stroke: "black",
    strokeWidth: 3.85228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8577,
    cy: 91.8772,
    r: 22.6428,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 1.96894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4121 84.9584C99.9888 84.3817 99.9888 83.4467 99.4121 82.87C98.8354 82.2933 97.9004 82.2933 97.3238 82.87L90.1283 90.0655L82.933 82.8702C82.3563 82.2935 81.4213 82.2935 80.8446 82.8702C80.2679 83.4469 80.2679 84.3819 80.8446 84.9586L88.0399 92.1539L80.8446 99.3492C80.2679 99.9258 80.2679 100.861 80.8446 101.438C81.4213 102.014 82.3563 102.014 82.933 101.438L90.1283 94.2422L97.3238 101.438C97.9004 102.014 98.8354 102.014 99.4121 101.438C99.9888 100.861 99.9888 99.926 99.4121 99.3493L92.2167 92.1539L99.4121 84.9584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/emptyState.8fbbf592f2986597b55dffb5cd00499e.svg";
export { ForwardRef as ReactComponent };